exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pc-rental .case-row {\n  text-align: right;\n  background-color: #a5a5a5;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  padding-left: 25px;\n}\n.pc-rental .case-row .col-xs-12 {\n  padding: 0;\n}", ""]);

// exports
